<template>
  <div id="TopImage" class="topImageCss" v-bind:style="{ 'background-image': 'url(' + 'https://wp-ocssport.ocs-sport.com/pinpos/wp-content/uploads/sites/9/2025/08/pinPosmain-min-1-scaled.png' + ')' }">
    <b-container><h3 class="pinPosTitle">PRECISION PIN POSITIONING <br> FOR EVERY GREEN</h3></b-container>
  </div>
</template>

<script>
export default {
  name: 'Top Image Section',
  components: {

  },
  methods: {
    // isMobile() {
    //     if( screen.width <= 768 ) {
    //         return true;
    //     }
    //     else {
    //         return false;
    //     }
    // },
  }
}
</script>
<style scoped>
.topImageCss {
    height: 637px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}
.pinPosTitle {
    font-size: 120px;
    font-family: DIN Condensed, Bold;
    text-align: left;
    position: relative;
    top: 150px;
}
@media only screen and (max-width: 1280px) {
  .topImageCss {
    height: 437px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right;
  }
  .pinPosTitle {
      font-size: 80px;
      font-family: DIN Condensed, Bold;
      text-align: left;
      position: relative;
      top: 100px;
  }
}
@media only screen and (max-width: 900px) {
  .pinPosTitle {
    display: none;
  }
}
</style>
